import { type BillingOverviewDto } from '../../services/billing.api';
import { i18nService, t, translateDocumentType } from '../../services/i18n';
import { type DocumentDto } from '../../services/api';

export const DOC_TYPES = ['Epc', 'Inspection', 'Insurance', 'Invoice', 'Photo', 'Other'] as const;

export function esc(str: string): string {
  const el = document.createElement('span');
  el.textContent = str;
  return el.innerHTML;
}

export function formatDate(dateStr?: string): string {
  if (!dateStr) return '-';
  return i18nService.formatDate(dateStr, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function isExpiringSoon(expiryDate?: string): boolean {
  if (!expiryDate) return false;
  const date = new Date(expiryDate);
  const diff = (date.getTime() - Date.now()) / (1000 * 60 * 60 * 24);
  return diff <= 30 && diff >= 0;
}

export function isExpired(expiryDate?: string): boolean {
  if (!expiryDate) return false;
  return new Date(expiryDate) < new Date();
}

export function formatBytes(bytes?: number | null): string {
  if (bytes == null || Number.isNaN(bytes)) {
    return '-';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = Math.max(0, bytes);
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  const decimals = value >= 10 || unitIndex === 0 ? 0 : 1;
  return `${value.toFixed(decimals)} ${units[unitIndex]}`;
}

export function renderStorageField(label: string, value: string): string {
  return `
    <div class="profile-info-row billing-info-row">
      <span class="profile-info-label">${esc(label)}</span>
      <span class="profile-info-value">${esc(value)}</span>
    </div>
  `;
}

export function getFilteredDocuments(documents: DocumentDto[], filterType: string): DocumentDto[] {
  if (!filterType) return documents;
  return documents.filter((document) => document.documentType === filterType);
}

export function renderEmptyMessage(filterType: string): string {
  return filterType
    ? t('document.emptyFiltered', { type: translateDocumentType(filterType) })
    : t('document.empty');
}

export function getPlanName(billingOverview: BillingOverviewDto | null): string {
  return billingOverview?.subscription.planName || billingOverview?.subscription.planKey || '-';
}
